<template>
  <div class="landing-flow">
    <WlWizard
      :style="{
        backgroundImage: 'url(' + this.cms.page.steps.background_image + ')'
      }"
      :current-step="3"
      :steps="3"
      :current-percent="0"
      :first-name="firstName"
      :last-name="lastName"
      :step-completed-icon="stepCompletedIcon"
    >
      <template v-slot:content>
        <div class="landing-flow__body-content" v-if="letter === 'a'">
          <div class="step-3a">
            <div class="step-3a__main-content">
              <WlStep
                :title="cms.page.steps.step_three_a.title"
                :sub-text="cms.page.steps.step_three_a.sub_text"
                :header-icon="cms.page.steps.step_three_a.icon"
              />
              <p class="step-3a__error" v-if="step3Aerror">{{ step3Aerror }}</p>
              <WlLeadForm
                :button-text="cms.page.steps.step_three_a.button_text"
                :member-text="cms.page.steps.step_three_a.member_text"
                :sign-in-text="cms.page.steps.step_three_a.sign_in_text"
                :sign-in-link="cms.page.steps.step_three_a.sign_in_link"
                :disclaimer-text="cms.page.steps.step_three_a.disclaimer_text"
                @wl-lead-form-submit="handleFormSubmit"
              />
            </div>
            <div class="step-3a__side-bar">
              <div class="step-3a__side-bar-heading">
                <img
                  class="step-3a__side-bar-question-icon"
                  :src="questionCircle"
                  alt="question-circle"
                />
                <h2 class="step-3a__side-bar-header">
                  {{ cms.page.steps.step_three_a.side_header }}
                </h2>
              </div>
              <div class="step-3a__side-bar-list">
                <div
                  class="step-3a__side-bar-item"
                  v-for="item in cms.page.steps.step_three_a.side_list"
                  :key="item.text"
                >
                  <TzMarkdown
                    class="step-3a__side-bar-item-text"
                    :content="item.text"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="wl-wizard__privacy-banner">
          <tz-markdown
            class="wl-wizard__privacy-banner-text"
            :content="cms.page.steps.privacy_banner_text"
          />
        </div>
      </template>
    </WlWizard>
    <transition name="modal-fade">
      <div v-if="isReportReadyModal" class="overlay overlay--show">
        <TzModal :open="isReportReadyModal">
          <div class="modal__heading">
            <img
              class="modal__heading-icon"
              :src="IconExclamation"
              alt="modal__heading-icon"
            />
            <h3 class="modal__heading-text">Important!</h3>
          </div>
          <div class="modal__body">
            <h3 class="modal__header">
              {{ setNameInText(cms.page.steps.step_three_a.modal_header) }}
            </h3>
            <TzMarkdown
              class="modal__subtext"
              :content="cms.page.steps.step_three_a.modal_subtext"
            />
            <TzAcknowledge
              :cta-text="cms.page.steps.step_three_a.modal_cta"
              :button-text="modalButtonText"
              :button-icon="RightArrow"
              :is-checked="isChecked"
              :is-required="isRequired"
              :checkbox-text="cms.page.steps.step_three_a.modal_checkbox_text"
              @tz-acknowledge-submit="handleButtonClick"
              @tz-acknowledge-checkbox-change="handleCheckboxChange"
            />
          </div>
        </TzModal>
      </div>
    </transition>
    <div class="tz-loading-bar-modal" v-if="isSubmitting">
      <TzLoadingBar
        :starting-position="0"
        :delay="this.$route.query.testing ? 30 : 70"
        @tz-loading-bar-completed="handleReportReadyModal()"
      >
        <p class="tz-loading-bar__text">
          {{ cms.page.steps.step_three_a.loading_modal_text }}
        </p>
      </TzLoadingBar>
    </div>
  </div>
</template>
<script>
import TzMarkdown from '@trazi/tz-markdown/src/tz-markdown.vue';
import TzModal from '@trazi/tz-modal/src/tz-modal.vue';
import TzAcknowledge from '@trazi/tz-acknowledge/src/tz-acknowledge.vue';
import WlWizard from '@/components/shared/wl-wizard';
import WlStep from '@/components/shared/wl-step';
import WlLeadForm from '@/components/shared/wl-lead-form';
import TzLoadingBar from '@trazi/tz-loading-bar/src/tz-loading-bar.vue';
import stepCompletedIcon from '@/assets/images/step-completed-icon.svg';
import questionCircle from '@/assets/images/circle-question.svg';
import landingHelper from '@/assets/js/landingHelper';
import RightArrow from '@/assets/images/icons/right-arrow.svg';
import IconExclamation from '@/assets/images/icon-exclamation.svg';
import leadsSDK from '@/assets/js/shared/services/leads-sdk';
import searchSDK from '@/assets/js/shared/services/search-sdk';
import setTitleCase from '@/assets/js/shared/helpers/setTitleCase';
import { isSafe } from 'assets/js/validationHelper';

const NBars = require('nbars/commonjs.js');
const pageCms = require(`@/assets/cms/pages/landing.json`);
const { steps_page_title: pageTitle, steps_meta_root: metaRoot } = pageCms;

export default {
  components: {
    WlStep,
    WlWizard,
    WlLeadForm,
    TzMarkdown,
    TzModal,
    TzAcknowledge,
    TzLoadingBar
  },
  data() {
    return {
      stepCompletedIcon,
      questionCircle,
      RightArrow,
      IconExclamation,
      isReportReadyModal: false,
      leadsSDK,
      letter: 'a',
      isRequired: true,
      isChecked: false,
      modalActive: null,
      step3Aerror: null,
      isSubmitting: false,
      searchSDK,
      firstName: null,
      lastName: null
    };
  },
  methods: {
    async handleFormSubmit(evt) {
      // If form is submitting don't handle submit
      if (this.isSubmitting) {
        return;
      }

      const firstName = evt.firstName;
      const lastName = evt.lastName;
      const email = evt.email;
      let data = landingHelper.getLandingSession();
      // Clean data with any falsy data
      data = Object.entries(data).reduce(
        (item, [key, value]) => (value ? ((item[key] = value), item) : item),
        {}
      );

      const newData = {
        ...data,
        leadFirst: firstName,
        leadLast: lastName,
        leadEmail: email
      };
      landingHelper.setLandingSession(newData);

      const leadData = {
        ...data,
        search: {
          firstName: landingHelper.formatFirstName(data.firstName),
          lastName: landingHelper.formatUnderScoreToSpace(data.lastName),
          state: data.state,
          city: landingHelper.formatUnderScoreToSpace(data.city)
        },
        firstName,
        lastName,
        email,
        domain:
          this.$config.environment === 'production'
            ? `${this.$config.website}.com`
            : this.$config.testingAccountDomain,
        pid: data.providerId,
        type: 'people'
      };
      this.isSubmitting = true;

      try {
        const leadsRes = await leadsSDK(window).Local.newLead(leadData);
        if (leadsRes.type.includes('error')) {
          return this.handleError(leadsRes.msg);
        }
      } catch (err) {
        this.$bugsnag?.notify(err);
        this.handleError(err);
      }
    },
    /**
     * Handle the error when submitting the lead form
     * @param {string} errorMessage
     * @param {number} delay
     */
    handleError(errorMessage, delay = 1000) {
      setTimeout(() => {
        this.isSubmitting = false;
        this.step3Aerror = errorMessage;
      }, delay);
    },
    handleReportReadyModal() {
      this.step3Aerror = null;
      this.isReportReadyModal = true;
      this.modalActive = true;
      this.isSubmitting = false;
    },
    handleButtonClick() {
      // Proceed to checkout page
      const landingID = this.$route.params.landingID;
      const query = this.$route.query;
      query.cachedres = true;
      const baseUrl = `${window.location.origin}${this.setLandingIdInText(
        this.cms.page.steps.checkout_url,
        landingID
      )}`;
      query.sessionId = localStorage.getItem('session_id');
      window.location.href = landingHelper.getLinkWithParams(baseUrl, query);
    },
    handleCheckboxChange(event) {
      this.isChecked = event;
    },
    setNameInText(text) {
      return NBars.transform(text, {
        name: setTitleCase({ text: this.name })
      });
    },
    setLandingIdInText(text, landingID) {
      return NBars.transform(text, {
        landingID
      });
    }
  },
  computed: {
    name() {
      return `${this.firstName} ${this.lastName}`;
    },
    modalButtonText() {
      const buttonText = this.cms.page.steps.step_three_a.modal_button_text;
      return buttonText.toUpperCase();
    }
  },
  updated() {
    // The link appears after the component updates and shows the modal
    let FcraLink = document.querySelector("a[href='#FcraLink']");

    if (FcraLink) {
      FcraLink.href = this.cms.page.steps.step_three_a.fcra_link;
      FcraLink.setAttribute('target', '_blank');
      FcraLink.setAttribute('rel', 'noFollow noReferrer');
    }
  },
  async validate({ params }) {
    return isSafe(params);
  },
  mounted() {
    sessionStorage.removeItem('checkout');
    landingHelper.checkUrlAndGetData(this);
  },
  watch: {
    // whenever modalActive changes, this function will run
    modalActive: function() {
      document.body.style.overflowY = this.modalActive ? 'hidden' : '';
    }
  },
  async asyncData({ $bugsnag, query, route, redirect }) {
    if (!process.server) {
      return;
    }

    const clientHasData = query.cachedres && query.cachedres === 'true';

    if (clientHasData) {
      return {};
    }

    const landingId = route.params.landingID;
    const resultsUrl = NBars.transform(pageCms.steps.results_url, {
      landingId
    });
    const stepThreeUrl = NBars.transform(pageCms.steps.step_three_url, {
      landingId
    });
    return await landingHelper.getPayloadOrRedirect(
      searchSDK,
      stepThreeUrl,
      resultsUrl,
      redirect,
      route,
      query,
      {},
      $bugsnag
    );
  },
  props: {
    cms: {
      type: Object,
      default: () => {
        return {
          page: pageCms
        };
      }
    }
  },
  head() {
    return landingHelper.getPageMetaAndTitle({
      city: this.$route.query.city,
      state: this.$route.query.state,
      firstName: this.$route.query.firstName,
      lastName: this.$route.query.lastName,
      stepNumber: 3,
      pageTitleCms: pageTitle,
      metaArr: metaRoot
    });
  }
};
</script>
